import React from 'react'
import { Link } from 'react-router-dom'

import Script from 'dangerous-html/react'
import PropTypes from 'prop-types'

import './navbar.css'

const Navbar = ({
  imageAlt = 'image',
  imageSrc1 = '/Branding/planical7012-ttpb.svg',
  imageSrc = '/Icons/hamburger-200h.png',
  imageAlt1 = 'image',
  rootClassName = '',
  brandingLogo = '/social-media-recruiting-agentur-logo-weiss.png',
  onContactClick,
}) => {
  const handleContactClick = () => {
    if (onContactClick) {
      onContactClick('Kostenlose Beratung - Navbar')
    }
  }

  return (
    <header className={`navbar-navbar ${rootClassName} `}>
      <Link to="/" style={{ textDecoration: 'none' }}>
        <img
          alt="Planical7012"
          src={brandingLogo}
          className="navbar-branding-logo"
        />
      </Link>
      <div className="navbar-nav-content">
        <nav className="navbar-desktop-nav">
          <Link to="/" className="navbar-nav-link">Home</Link>
          <Link to="/cases" className="navbar-nav-link">Cases</Link>
          <Link to="/ueber-uns" className="navbar-nav-link">Über uns</Link>
        </nav>
        <div className="get-started navbar-get-started1" style={{ backgroundColor: '#bbd8a7', cursor: 'pointer' }} onClick={handleContactClick}>
          <span className="navbar-text1">Kostenlose Beratung</span>
        </div>
        <div id="open-mobile-menu" className="navbar-hamburger get-started">
          <img
            alt={imageAlt}
            src={imageSrc}
            className="navbar-image1"
          />
        </div>
      </div>
      <div id="mobile-menu" className="navbar-mobile-menu">
        <div className="navbar-branding">
          <img
            alt={imageAlt1}
            src={imageSrc1}
            className="navbar-image2"
          />
          <div id="close-mobile-menu" className="navbar-container1">
            <svg viewBox="0 0 1024 1024" className="navbar-icon1">
              <path d="M225.835 286.165l225.835 225.835-225.835 225.835c-16.683 16.683-16.683 43.691 0 60.331s43.691 16.683 60.331 0l225.835-225.835 225.835 225.835c16.683 16.683 43.691 16.683 60.331 0s16.683-43.691 0-60.331l-225.835-225.835 225.835-225.835c16.683-16.683 16.683-43.691 0-60.331s-43.691-16.683-60.331 0l-225.835 225.835-225.835-225.835c-16.683-16.683-43.691-16.683-60.331 0s-16.683 43.691 0 60.331z"></path>
            </svg>
          </div>
        </div>
        <nav className="navbar-mobile-nav">
          <Link to="/" className="navbar-mobile-nav-link" onClick={() => document.querySelector("#mobile-menu").style.transform = "translateX(100%)"}>Home</Link>
          <Link to="/cases" className="navbar-mobile-nav-link" onClick={() => document.querySelector("#mobile-menu").style.transform = "translateX(100%)"}>Cases</Link>
          <Link to="/ueber-uns" className="navbar-mobile-nav-link" onClick={() => document.querySelector("#mobile-menu").style.transform = "translateX(100%)"}>Über uns</Link>
        </nav>
        <div className="get-started" style={{ backgroundColor: '#bbd8a7', cursor: 'pointer' }} onClick={handleContactClick}>
          <span className="navbar-text2">Kostenlose Beratung</span>
        </div>
      </div>
      <div>
        <div className="navbar-container3">
          <Script
            html={`<script defer>
    /*
Mobile menu - Code Embed
*/

(function() {
    // Check if already initialized to prevent duplicate declarations
    if (window._mobileMenuInitialized) return;
    window._mobileMenuInitialized = true;

    /* listenForUrlChangesMobileMenu() makes sure that if you changes pages inside your app, 
    the mobile menu will still work*/

    const listenForUrlChangesMobileMenu = () => {
        let url = location.href;
        document.body.addEventListener("click", () => {
            requestAnimationFrame(() => {
                if (url !== location.href) {
                    runMobileMenuCodeEmbed();
                    url = location.href;
                }
            });
        },
        true
        );
    };

    const runMobileMenuCodeEmbed = () => {
        // Mobile menu
        const mobileMenu = document.querySelector("#mobile-menu")

        // Buttons
        const closeButton = document.querySelector("#close-mobile-menu")
        const openButton = document.querySelector("#open-mobile-menu")

        // On openButton click, set the mobileMenu position left to -100vw
        openButton && openButton.addEventListener("click", function() {
            mobileMenu.style.transform = "translateX(0%)"
        })

        // On closeButton click, set the mobileMenu position to 0vw
        closeButton && closeButton.addEventListener("click", function() {
            mobileMenu.style.transform = "translateX(100%)"
        })
    }

    runMobileMenuCodeEmbed()
    listenForUrlChangesMobileMenu()
})();
</script>`}
          ></Script>
        </div>
      </div>
    </header>
  )
}

Navbar.propTypes = {
  imageAlt: PropTypes.string,
  imageSrc1: PropTypes.string,
  imageSrc: PropTypes.string,
  imageAlt1: PropTypes.string,
  rootClassName: PropTypes.string,
  brandingLogo: PropTypes.string,
  onContactClick: PropTypes.func,
}

export default Navbar
